<template>
  <section class="form">
    <span class="form__label">
      <span> {{ label }} </span>
      <a-tooltip title="Información">
        <InfoCircleOutlined class="tooltip__icon" theme="filled" />
      </a-tooltip>
    </span>
    <a-form layout="vertical" ref="form" :model="formState" :rules="rules" hide-required-mark>
      <a-form-item class="form__item" name="seconds">
        <span> Segundos: </span>
        <a-input-number v-model:value="model" class="form__input" :min="0" />
      </a-form-item>
    </a-form>
  </section>
</template>

<script>
import { defineComponent, ref, reactive } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  components: {
    InfoCircleOutlined,
  },
  props: {
    value: { required: true, type: Number },
    label: { required: true, type: String },
  },
  setup(props) {
    const form = ref();
    const formState = reactive({
      seconds: props.value,
    });
    const rules = {
      seconds: [
        {
          pattern: /[0-9]{2}/,
          message: "Solo números",
        },
        { required: true, message: "Campo requerido" },
      ],
    };
    return {
      form,
      formState,
      rules,
    };
  },
  data() {
    return {
      // form: this.$form.createForm(this, {
      //   onValuesChange: (_, fields) =>
      //     this.$emit("input", parseInt(fields.second)),
      // }),
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        const number = parseInt(value);
        if (isNaN(number)) return;
        this.$emit("update:value", number);
      },
    },
  },
  methods: {
    // setModel(value) {
    //   // this.model = value;
    // },
  },
});
</script>

<style lang="sass" scoped>
.form
  &__label
    font-weight: 600
    color: $gray-9

  &__item
    margin-top: 8px

  &__input
    width: 80px

.tooltip
  &__icon
    color: $gray-6
    margin-left: 4px
</style>
